// Native (Capacitor) bootstrap. No-op on the web build so the browser app is
// completely unaffected. All plugin imports are dynamic and guarded.
export async function initNative() {
  let Capacitor;
  try {
    ({ Capacitor } = await import("@capacitor/core"));
  } catch {
    return; // Capacitor not installed in this environment — plain web.
  }
  if (!Capacitor?.isNativePlatform?.()) return;

  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Light });
  if (Capacitor?.isNativePlatform?.() && Capacitor.getPlatform() === "android") {
        await StatusBar.setOverlaysWebView({ overlay: false });
      }
  } catch {}

  // Preserve the static native composition until the equivalent HTML frame can paint.
  document.documentElement.classList.add('cc-native-launch');
  try {
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch {}

  try {
    const { Keyboard } = await import("@capacitor/keyboard");
    await Keyboard.setAccessoryBarVisible?.({ isVisible: true });
  } catch {}

  try {
    const { App } = await import("@capacitor/app");
    App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.exitApp();
    });
  } catch {}
}


// Synchronous native-platform check (safe on web where Capacitor is absent).
export function isNativePlatform() {
  try {
    return !!(typeof window !== "undefined" && window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch {
    return false;
  }
}

